var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_896_500)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_896_500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.38717 13.7422V26.4459L4.28601 26.0788V13.7422H5.38717Z",
    fill: "#36B22D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.09443 28.2454C6.16605 28.2812 6.24662 28.317 6.31824 28.3259C6.39882 28.3438 6.44358 28.3438 6.60473 28.3438H18.5385V29.445H6.96283C6.7032 29.4361 6.48834 29.4719 6.07653 29.4002C5.97805 29.0063 5.987 28.5945 6.09443 28.2454Z",
    fill: "#00A5E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.31826 28.3259C5.99597 28.2632 5.68263 27.9499 5.53043 27.547C5.44986 27.35 5.4051 27.1262 5.39615 26.9024V26.0698H4.29498C4.29498 26.4548 4.3666 26.8397 4.60832 27.2516C4.73366 27.4396 4.86795 27.6097 5.02014 27.744C5.38719 28.2095 5.9512 28.4512 6.32721 28.3259H6.31826Z",
    fill: "#36B22D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07654 29.4091C5.53044 29.2927 5.14548 28.8541 5.05595 28.4064C5.00224 28.1826 4.99328 27.9677 5.01119 27.7618C5.16338 27.8961 5.32453 28.0125 5.49463 28.0841C5.83482 28.2363 6.1034 28.29 6.31826 28.3438L6.08549 29.4181L6.07654 29.4091Z",
    fill: "#00A5E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4785 1.90689C19.3353 1.53089 19.0488 1.2265 18.7534 1.13697C18.6728 1.11012 18.6012 1.10116 18.5206 1.10116H7.80438L8.17144 0H18.1983C18.3326 0 18.4311 0 18.6012 0C18.7892 0 18.9682 0.0447628 19.1383 0.0984781C19.8277 0.340197 20.2753 0.91316 20.5081 1.49508L19.4785 1.89794V1.90689Z",
    fill: "#36B22D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.77213 1.4772C5.53042 1.76368 5.38717 2.18445 5.38717 2.60522V4.18982V7.36798V13.7332H4.28601V2.94542C4.28601 2.71265 4.28601 2.39931 4.33973 2.07702C4.39344 1.77263 4.49192 1.46824 4.65307 1.18176C5.05593 1.21757 5.44089 1.31605 5.78109 1.4772H5.77213Z",
    fill: "#00A5E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.61102 1.70994C5.81693 1.33393 6.14818 1.10116 6.47942 1.10116H8.18041V0C7.78649 0 7.40153 0.0895255 7.03448 0.277529L6.47942 0.555058C5.8975 0.752014 5.65579 1.26231 5.61998 1.70994H5.61102Z",
    fill: "#36B22D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6441 1.18174C4.86792 0.760973 5.33345 0.420776 5.82584 0.420776C6.06756 0.420776 6.29137 0.465539 6.47938 0.555065C6.29137 0.653543 6.15709 0.778878 6.04965 0.922119C5.8527 1.2086 5.75422 1.46822 5.61098 1.7189L4.6441 1.1907V1.18174Z",
    fill: "#00A5E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5295 28.3527C20.1141 28.2632 19.4785 25.3715 19.6128 23.4109V17.0546L20.7139 17.4216V26.6786C20.7408 27.2247 20.6155 27.914 20.2574 28.4512C19.9172 28.9973 19.2726 29.4718 18.5206 29.4628V28.3616L18.5295 28.3527Z",
    fill: "#36B22D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6128 14.4136V3.27663C19.6128 3.02596 19.6128 2.71262 19.6128 2.50671C19.6038 2.30081 19.559 2.0949 19.4874 1.90689L20.517 1.50403C20.6334 1.79946 20.696 2.1128 20.7229 2.41719C20.7408 2.73948 20.7229 2.95434 20.7229 3.22292V14.0197L19.6217 14.4136H19.6128Z",
    fill: "#00A5E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6128 14.0287V17.4217H20.714C20.714 17.0367 20.6244 16.6518 20.4364 16.2758L20.1589 15.7207L19.6128 14.0287Z",
    fill: "#36B22D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7139 14.0197C20.7139 14.4046 20.6244 14.7896 20.4364 15.1656L20.1589 15.7206L19.8814 15.1656C19.6933 14.7896 19.6038 14.4046 19.6038 14.0197H20.705H20.7139Z",
    fill: "#00A5E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7068 4.08237H12.6924L12.7551 2.9812H14.7068V4.08237Z",
    fill: "#36B22D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2806 4.08237H10.2663V2.9812H12.218L12.2806 4.08237Z",
    fill: "#00A5E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.218 4.08237H12.7551V2.9812C12.6924 2.9812 12.6298 3.07073 12.5761 3.25873L12.4865 3.53626L12.218 4.08237Z",
    fill: "#36B22D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.218 2.9812C12.2806 2.9812 12.3433 3.07073 12.397 3.25873L12.4865 3.53626L12.397 3.81379C12.3343 4.00179 12.2806 4.09132 12.218 4.09132V2.99015V2.9812Z",
    fill: "#00A5E3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_896_500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_896_500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.538,
    height: 30,
    fill: "white",
    transform: "translate(3.73096)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePlaceholder);
export default __webpack_public_path__ + "static/media/mobile-placeholder.26c73e1189cc2b2d6065d68e25aa91d9.svg";
export { ForwardRef as ReactComponent };